import React from "react";
import { styled } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import IconAvatarStyled from "../IconAvatarStyled";

const WhatsAppIconStyled = styled(WhatsAppIcon)(({ theme }) => ({
  color: theme.palette.brand.whatsapp,
  fontSize: 24,
}));

export const WapNavIcon: React.FC = () => (
  <IconAvatarStyled alt="WhatsApp Avatar">
    <WhatsAppIconStyled />
  </IconAvatarStyled>
);
